import type { IDayWorkHour } from "@/interfaces/IDayWorkHour";
import { ArchiveState } from "@/store/Crud/functions/archived/State";

export class State extends ArchiveState {
  workHours: Array<IDayWorkHour> = [];
  instructorListToManage: Array<any> = [];
}
